module.exports = __webpack_public_path__ + "static/img/ceded6fdeeb61da71d4c0fa9c36d313c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_adv2.jpg
// module id = rY0M
// module chunks = 1